import React from 'react';
import ShowFeedbackCopy from '../ShowFeedbackCopy/ShowFeedbackCopy';

import './copyToClipboard.css';

export default function CopyToClipboard({ textToCopy }) {

  const copyToClipboard = () => {
    navigator.clipboard.writeText(textToCopy);
  };

  return (
    <div className="copy-icon" onClick={copyToClipboard}>
      <i className="icon icon-copy text-black ml-3"></i>
      {/* <ShowFeedbackCopy /> */}
    </div>
  )
}
